import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";

  @Component({
    selector: "usb-rent-a-car-result",
    templateUrl: "./rent-a-car-result.component.html",
    styleUrls: ["../../../base-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
  })
export class RentACarResultComponent implements OnInit {

  @Input() result: any;
  @Input() clientsSettingAppBooking;

  constructor() {}

  ngOnInit() {
  }

}
